import { KK_MONTHS } from 'common/constants';
import { getNumberFormatter, LOCALES } from 'utils';
import { DeliveryMethod, DeliveryMethodResponse, RTPData, RTPResponse } from './types';

export const processResponse = (response: RTPResponse, locale: string): RTPData => {
  const result: RTPData = {
    productId: response.productId,
    regionId: response.regionId,
    stocks: response.stocks,
    longtailCase: response.longtailCase,
    isOnlineOnly: response.isOnlineOnly,
    unit: response.unit,
    deliveryMethods: response.deliveryMethods.map(
      (m) =>
        ({
          type: m.type,
          price: formatDeliveryMethodPrice(m, locale),
          date: m.date,
          title: `${m.title} ${formatDate(new Date(m.date), locale)}`,
          maxStockAvailable: m.maxStockAvailable,
        }) as DeliveryMethod,
    ),
  };

  return result;
};

const formatDeliveryMethodPrice = (data: DeliveryMethodResponse, locale: string): string => {
  return Math.floor(data.price) > 0
    ? `от ${getNumberFormatter(locale, {
        style: 'currency',
        currency: data.currencyKey,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(data.price)}`
    : 'бесплатно';
};

export const getProductAvalibilityFromSourse = (deliveryMethods: DeliveryMethod[]) => {
  let typePickup = '';
  let typeDelivery = '';
  deliveryMethods.forEach((el) => {
    const formattedDate = formatDateToGa(el.date);
    if (el.type === 'PICKUP') {
      typePickup = `S-${formattedDate}`;
    }
    if (el.type === 'HOME_DELIVERY') {
      typeDelivery = `D-${formattedDate}`;
    }
  });
  return `${typePickup}/${typeDelivery}`;
};

const formatDateToGa = (date: string) =>
  new Date(date).toLocaleDateString('ru-RU', { year: '2-digit', day: '2-digit', month: '2-digit' });

export const formatDate = (date: Date, locale: string) => {
  // HACK: https://issues.chromium.org/issues/494171687
  if (locale === LOCALES.get('kk')) {
    const day = date.getDate();
    const month = KK_MONTHS[date.getMonth()];
    return `${day} ${month}`;
  }

  return date.toLocaleDateString(locale, { day: 'numeric', month: 'long' });
};
